import React, { useState } from "react";

const App = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  // Replace this with your live streaming radio URL
  const radioStreamUrl = "https://stream-172.zeno.fm/fvkxfw0svtzuv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJmdmt4Zncwc3Z0enV2IiwiaG9zdCI6InN0cmVhbS0xNzIuemVuby5mbSIsInJ0dGwiOjUsImp0aSI6ImdqX3E0emdmUlJDR1ZRbTluQzZXM2ciLCJpYXQiOjE3MzUyMTI1NjMsImV4cCI6MTczNTIxMjYyM30.comcYU9b5bLHYy9wzPVfJxK5HGADK55L3VdWbIEIrno";

  const togglePlay = () => {
    const audioElement = document.getElementById("radio-audio");
    if (!isPlaying) {
      audioElement.play();
    } else {
      audioElement.pause();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div style={styles.app}>
      {/* Header Section */}
      <header style={styles.header}>
        <h1 style={styles.headerTitle}>Ruimbo FM</h1>
        <p style={styles.subTitle}>Your Favorite Radio Station - Streaming Live</p>
      </header>

      {/* Content Section */}
      <div style={styles.content}>
        <h2 style={styles.title}>Listen Live</h2>
        <audio id="radio-audio" src={radioStreamUrl}></audio>
        <button style={styles.button} onClick={togglePlay}>
          {isPlaying ? "Pause Radio" : "Play Radio"}
        </button>
      </div>

      {/* Footer Section */}
      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2024 Ruimbo FM. All rights reserved.</p>
      </footer>
    </div>
  );
};

const styles = {
  app: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#030344", // navy blue background
    color: "#fff", // White text
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between", // Push header, content, and footer apart
  },
  header: {
    backgroundColor: "#d32f2f", // yellow like color
    padding: "20px",
    textAlign: "center",
  },
  headerTitle: {
    fontSize: "2.5rem",
    margin: "0",
  },
  subTitle: {
    fontSize: "1.2rem",
    margin: "5px 0 0 0",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Center content vertically
    alignItems: "center", // Center content horizontally
    textAlign: "center",
  },
  title: {
    fontSize: "2rem",
    marginBottom: "20px",
  },
  button: {
    padding: "15px 30px",
    fontSize: "18px",
    color: "#fff",
    backgroundColor: "#d32f2f", // Red button
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  buttonHover: {
    backgroundColor: "#b71c1c", // Darker red on hover
  },
  footer: {
    backgroundColor: "#ffc800", // Dark footer
    padding: "10px 0",
    textAlign: "center",
  },
  footerText: {
    fontSize: "0.9rem",
    margin: "0",
    color: "#b71c1c",
  },
};

export default App;

